import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';

import {
  createReservation,
  rescheduleBooking,
  setRescheduleObject,
  fetchBooking,
} from 'actions/reservationActions';
import { openModal } from 'actions/modalActions';
import { setBookingData } from 'actions/userActions';
import { selectDayAndService } from 'actions/filterActions';

import Alert from 'components/alerts/Alert/Alert';
import AlertDanger from 'components/alerts/AlertDanger/AlertDanger';
import StripeSubscriptionWarning from 'components/alerts/StripeSubscriptionWarning/StripeSubscriptionWarning';
import Loading from 'components/Loading/Loading';
import TeacherAvailability from 'components/TeacherAvailability/TeacherAvailability';
import TeacherProfile from 'components/TeacherProfile/TeacherProfile';
import TeacherBookingButton from 'components/TeacherBookingButton';

import './style.css';

class TeacherBooking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTimeSlot: null,
      isSubmitting: false,
      isBookingFetching: false,
      bookingFetchError: null,
      bookingData: null,
    };
  }

  componentDidMount() {
    if (
      this.props.location.query.lessonId &&
      !this.props.rescheduleObject
    ) {
      this.getBooking(this.props.location.query.lessonId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedDay !== this.props.selectedDay) {
      this.setState({
        selectedTimeSlot: null,
      });
    }

    if (
      this.props.bookingData &&
      this.props.user.id &&
      // TODO: we'll want to check status of this live subscription but even better
      // would be checking that status outside of this component and not loading this
      // component if the user has problems with their account
      // FYI: right now we handle this on the server side so we'll consider this an
      // improvement on the UX and not a mandatory feature.
      this.props.user.live_subscription &&
      this.props.user.live_subscription.id
    ) {
      this.props.createReservation(this.props.bookingData);
      this.props.setBookingData(null);
    }
  }

  getBooking = async (lessonId) => {
    this.setState({ isBookingFetching: true });
    fetchBooking(lessonId, this.props.userToken, (lesson) => {
      this.handleLessonToReschedule(lesson);
    }, (error) => {
      this.setState({ bookingFetchError: error, isBookingFetching: false });
    });
  }

  handleLessonToReschedule = (lesson) => {
    const selectedDay = moment(lesson.startTime).clone().startOf('day');
    this.props.setRescheduleObject(lesson);
    this.props.selectDayAndService(selectedDay, { id: lesson.serviceId });
    this.setState({ isBookingFetching: false });
  }

  isValidCustomerRecord = (user) => {
    if (
      user &&
      user.givenName &&
      user.familyName &&
      user.email &&
      user.skypeName &&
      user.skypeName.length > 3
    ) {
      return true;
    }

    return false;
  };

  handleSelectTimeSlot = (timeSlot) => {
    this.setState({
      selectedTimeSlot: timeSlot,
    });
  };

  handleClickBooking = (teacher) => {
    const { selectedTimeSlot } = this.state;
    const { rescheduleObject } = this.props;

    if (!this.props.serviceId) {
      alert('You need to select a language from the sidebar before booking');
      return;
    }

    const bookingData = {
      startDateTime: selectedTimeSlot.startDateTime,
      endDateTime: selectedTimeSlot.endDateTime,
      duration: selectedTimeSlot.duration,
      teacherId: teacher.id,
      serviceId: this.props.serviceId,
    };

    if (this.props.isAuthenticated) {
      this.setState({ isSubmitting: true, bookingData });
      // if the rescheduleId is set, update the reservation
      // else create a new one
      if (rescheduleObject) {
        // add bookingId property to bookingData
        // and send to rescheduleBooking
        this.props.rescheduleBooking({
          originalBooking: rescheduleObject,
          ...bookingData,
        });
      } else {
        this.props.createReservation(bookingData, false, null, () => this.setState({ isSubmitting: false }));
      }
    } else {
      this.props.openModal('signup-modal', {
        bookingData,
      });
    }
  };

  checkAvailableUpgrade = () => {
    const { stripePlan } = this.props.user;
    return stripePlan && !stripePlan.isHighestPlan;
  };

  planLimitError = (duration) => {
    const noTimeLeftError =
      'You have already booked your max lessons for this month';
    const try30MinsError =
      "You don't have have enough minutes to book a 60 minute lesson, try 30 minutes.";
    const { rescheduleObject } = this.props;
    const { minutesLeft } = this.props.user;

    const rescheduleStartTime = rescheduleObject ?
      moment(rescheduleObject.startTime) :
      null;

    const nextCycleStart = moment(minutesLeft.next.start);
    if (this.props.selectedDay.isBefore(nextCycleStart)) {
      // Add minutes from a lesson we are rescheduling
      const rescheduleMinutesOffset =
        rescheduleStartTime && rescheduleStartTime.isBefore(nextCycleStart) ?
          rescheduleObject.duration :
          0;
      const adjustedMinutesLeft =
        minutesLeft.current.minutes + rescheduleMinutesOffset;
      if (adjustedMinutesLeft < duration) {
        return adjustedMinutesLeft >= 30 ? try30MinsError : noTimeLeftError;
      }
    } else {
      // Add minutes from a lesson we are rescheduling
      const rescheduleMinutesOffset =
        rescheduleStartTime && rescheduleStartTime.isSameOrAfter(nextCycleStart) ?
          rescheduleObject.duration :
          0;
      const adjustedMinutesLeft =
        minutesLeft.next.minutes + rescheduleMinutesOffset;
      if (adjustedMinutesLeft < duration) {
        return adjustedMinutesLeft >= 30 ? try30MinsError : noTimeLeftError;
      }
    }

    return null;
  };

  renderLoading() {
    return (
      <div className="TeacherBooking">
        <Loading />
      </div>
    );
  }

  renderError(error, classes) {
    return (
      <div className="TeacherBooking">
        <AlertDanger className={classes} error={error} />
      </div>
    );
  }

  renderReservationError(error, teacher, user) {
    if (
      error.statusText === 'Monthly Booking Limits Exceeded' &&
      this.checkAvailableUpgrade()
    ) {
      this.props.openModal('upgrade-membership-modal');
    } else if (error.trialCreditsRemaining !== null) {
      if (error.trialCreditsRemaining > 0) {
        this.props.openModal('buy-trial-credit-modal', {
          teacher,
          stripeCustomerId: user.stripeCustomerId,
          bookingData: this.state.bookingData,
          onPurchased: () => {
            this.setState({ isSubmitting: true });
            this.props.createReservation(
              this.state.bookingData,
              false,
              null,
              () => this.setState({ isSubmitting: false, bookingData: null })
            );
          },
        });
      } else if (error.trialCreditsRemaining === 0) {
        setTimeout(() => {
          this.props.setBookingData(this.state.bookingData);
          browserHistory.push(
            '/activate?plan=language_4_8pr&src=trialEndedModal'
          );
        }, 300);
      } else {
        console.log('SHOULD NOT GET HERE, maybe throw exception');
      }
      return <div />;
    }
    return <AlertDanger className="ReservationError" error={error} />;
  }

  renderSubscriptionWarning() {
    return (
      <div className="TeacherBooking">
        <StripeSubscriptionWarning />
      </div>
    );
  }

  renderTeacherNotFoundWarning() {
    return (
      <div className="TeacherBooking">
        <Alert className="TeacherNotFoundWarning" alertType="warning">
          <h4>
            We are unable to find this teacher. Please select a different one.
          </h4>
        </Alert>
      </div>
    );
  }

  renderBackLink() {
    return (
      <li className="breadcrumb-item" aria-current="page">
        <Link to="/schedule-lesson">
          <i className="fa fa-chevron-left mr-1" />{' '}
          <span className="breadcrumb-text"> Teacher List </span>
        </Link>
      </li>
    );
  }

  renderCustomerError() {
    return (
      <div className="BookingConfirmation">
        <Alert className="BookingConfirmationCustomerError" alertType="danger">
          <h4 className="mt-2 mb-4">
            It looks like there is a problem with your profile.
            <br />
            <small>
              You will need to update your account before booking a lesson.{' '}
            </small>
          </h4>

          <Link to="/profile/edit" className="btn btn-primary">
            Update Profile
          </Link>
        </Alert>
      </div>
    );
  }

  renderPlanLimitError(message) {
    return (
      <div className="TeacherBooking">
        <Alert className="TeacherNotFoundWarning" alertType="warning">
          <h4>{message}</h4>
        </Alert>
      </div>
    );
  }

  renderBookingContainer(teacher) {
    const { status } = this.props.reservations;
    const { bookingFetchError, isBookingFetching } = this.state;

    if (status === 'loading' || isBookingFetching) {
      return (
        <div className="BookingContainer">
          <Loading />
        </div>
      );
    }

    if (bookingFetchError) {
      const errorMessage = _.get(bookingFetchError, 'response.data', 'Something went wrong');
      return (<div className="booking-container">
        { errorMessage }
      </div>)
    }

    let errorContainer;

    if (this.props.isAuthenticated && this.props.user.minutesLeft) {
      // Maybe a little hacky but just get the duration from the first slot ...
      const firstSlot = teacher.slots[0];
      const duration = firstSlot ? firstSlot.duration : 30;
      const e = this.planLimitError(duration);
      if (e) errorContainer = this.renderPlanLimitError(e);
    } else if (status === 'error') {
      errorContainer = this.renderReservationError(
        this.props.reservations.error,
        teacher,
        this.props.user
      );
    } else if (
      this.props.isAuthenticated &&
      !this.isValidCustomerRecord(this.props.user)
    ) {
      errorContainer = this.renderCustomerError();
    }

    return (
      <Fragment>
        {errorContainer}
        <TeacherAvailability
          availableTimes={teacher.slots}
          onSelectTimeSlot={this.handleSelectTimeSlot}
          selectedTimeSlot={this.state.selectedTimeSlot}
        />
      </Fragment>
    );
  }

  render() {
    const { selectedTimeSlot } = this.state;
    const { isAuthenticated, user } = this.props;

    // TODO: A stripe error should come in our user object and ideally would never
    // come down to this component. We should check that before this component is loaded
    // in a parent component or HOC
    // if (isAuthenticated && stripeCustomer && stripeCustomer.error) {
    //   return this.renderError(stripeCustomer.error, 'StripeSubscriptionError');
    // }
    // if (
    //   isAuthenticated &&
    //   (stripeCustomer.delinquent === true || _.isEmpty(this.props.activeStripeSubscriptions))
    // ) {
    //   return this.renderSubscriptionWarning();
    // }

    if (
      _.isEmpty(this.props.availability) ||
      this.props.availability.status === 'loading'
    ) {
      return (
        <div className="BookingContainer">
          <Loading />
        </div>
      );
    }

    // find the teacher by the url parameter
    const availableTimes = _.get(this.props.availability, 'availableTimes', []);
    const teacher = _(availableTimes).find((teacherSingle) => {
      return teacherSingle.slug === this.props.params.slug;
    });

    return (
      <div className="TeacherBooking hasBookingButton">
        <nav aria-label="breadcrumb" role="navigation">
          <ol className="breadcrumb pt-3 mb-0">{this.renderBackLink()}</ol>
        </nav>

        {teacher && <TeacherProfile teacher={teacher} user={user} showVideo />}

        {teacher && (
          <div className="card">
            <div className="card-block">
              <div className="booking-container">
                {this.renderBookingContainer(teacher)}
              </div>
            </div>
          </div>
        )}

        {!teacher && (
          <div className="card">
            <div className="card-block">
              <div className="booking-container">
                No Available Times for this teacher
              </div>
            </div>
          </div>
        )}

        {teacher && selectedTimeSlot && (
          <TeacherBookingButton
            isAuthenticated={isAuthenticated}
            onClick={() => this.handleClickBooking(teacher)}
            selectedTimeSlot={selectedTimeSlot}
            disabled={this.state.isSubmitting}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !_.isEmpty(state.user.profile),
    alerts: state.alerts,
    bookingData: state.user.bookingData,
    rescheduleObject: state.reservations.rescheduleObject,
    reservations: state.reservations,
    selectedDay: state.filters.selectedDay,
    serviceId: state.filters.selectedService.id,
    availability: state.availability,
    user: state.user.profile,
    userToken: state.user.token,
  };
}

export default connect(mapStateToProps, {
  openModal,
  createReservation,
  rescheduleBooking,
  setBookingData,
  setRescheduleObject,
  selectDayAndService,
})(TeacherBooking);



// WEBPACK FOOTER //
// ./src/pages/student/TeacherBooking/index.js